import {
  ref,
} from 'vue'

import { useAjax } from '@composables/useAjax.js'
import { useAuthentication } from '@composables/useAuthentication.js'

const bookmarkedSet = ref(new Set())

export const useBookmarkProperty = () => {
  const { callDestroy, callGet, callPost } = useAjax()
  const { isSignedIn, signedOutToStorage } = useAuthentication()

  const bookmark = async (code) => {
    try {
      const response = await callPost(`/saved-properties.json`, { code })
      set.add(code)
      return response.code == 'success'
    }
    catch (e) {
      handleError(e)
    }
  }

  const getBookmark = async (code) => {
    if (!isSignedIn()) return false

    try {
      const response = await callGet(`/saved-properties/${code}.json`)
      return response.code == 'success'
    }
    catch (e) {
      if (e && e.response && e.response.status == 401) {
        signedOutToStorage()
      }
    }
  }

  const getBookmarks = async () => {
    if (!isSignedIn()) return []

    try {
      const response = await callGet(`/saved-properties.json`)
      if (response.properties) {
        bookmarkedSet.value = new Set(response.properties.map((property) => property.code))
      }
      return response.properties
    }
    catch (e) {
      if (e && e.response && e.response.status == 401) {
        signedOutToStorage()
      }
    }
  }

  const unbookmark = async (code) => {
    try {
      const response = await callDestroy(`/saved-properties/${code}.json`)
      set.delete(code)
      return response.code == 'success'
    }
    catch (e) {
      handleError(e)
    }
  }

  // private

  const handleError = (e) => {
    if (e && e.response && e.response.status == 401) {
      location.href = e.response.data.path
    }
  }

  return {
    // variables
    bookmarkedSet,
    // methods
    bookmark,
    getBookmark,
    getBookmarks,
    unbookmark
  }
}
